import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useTheme from '../../hooks/useTheme';
import Tooltip from '../../components/tooltip/Tooltip';

const Label = ({
	onClick,
	onMouseHover = false,
	label,
	labelPrefix,
	labelPostfix,
	type,
	fontSize,
	fontFamily,
	style = {},
	tooltipText,
	tooltipWidth,
	textTransform,
	direction = 'bottom', // Default direction set to 'bottom'
	tooltipHeading, // New prop for optional tooltip heading
	offsetX,
}) => {
	const { color, FontFace } = useTheme('LIGHT');
	const [isHover, setIsHover] = useState(false);

	const styles = {
		fontFamily: fontFamily ? fontFamily : 'Inter-Regular',
		textTransform: textTransform,
		color:
			type === 'primary'
				? color.text.primary
				: type === 'secondary'
					? color.text.secondary
					: type === 'disabled'
						? color.text.disabled
						: type === 'highlight'
							? color.text.highlight
							: type === 'hyperlink'
								? color.text.hyperlink
								: type === 'hyperlink_hover'
									? color.text.hyperlink_hover
									: type === 'hyperlink_focus'
										? color.text.hyperlink_focus
										: type === 'success'
											? color.text.success
											: type === 'error'
												? color.text.error
												: type === 'white'
													? color.text.tertiary
													: color.background.primary,

		fontSize:
			fontSize === 'xxxxx_large'
				? FontFace.font_size.xxxxx_large
				: fontSize === 'xxxx_large'
					? FontFace.font_size.xxxx_large
					: fontSize === 'xx_large'
						? FontFace.font_size.xx_large
						: fontSize === 'xxx_large'
							? FontFace.font_size.xxx_large
							: fontSize === 'x_large'
								? FontFace.font_size.x_large
								: fontSize === 'large'
									? FontFace.font_size.large
									: fontSize === 'l_medium'
										? FontFace.font_size.l_medium
										: fontSize === 'x_medium'
											? FontFace.font_size.x_medium
											: fontSize === 'medium'
												? FontFace.font_size.medium
												: fontSize === 'small_medium'
													? FontFace.font_size.small_medium
													: fontSize === 'small'
														? FontFace.font_size.small
														: fontSize === 'input_text'
															? FontFace.font_size.input_text
															: fontSize === 'x_small'
																? FontFace.font_size.x_small
																: fontSize === 'xx_inputlabel'
																	? FontFace.font_size.xx_inputlabel
																	: fontSize === 'xx_small'
																		? FontFace.font_size.xx_small
																		: fontSize === 'xxx_small'
																			? FontFace.font_size.xx_small
																			: FontFace.font_size.input_text,
	};

	const mergedStyles = { ...styles, ...style }; // merge default styles with inline styles
	const subLabelStyles = {
		fontSize: FontFace.font_size.x_small, // Smaller font size
		color: color.text.primary, // Optional: secondary color
		marginLeft: '4px', // Space between label and subLabel
	};
	const labelElement = (
		<label
			onMouseEnter={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
			onClick={onClick}
			style={
				isHover && onMouseHover
					? { ...mergedStyles, color: color.text.hyperlink }
					: mergedStyles
			}
		>
			{labelPrefix && <>{labelPrefix}&nbsp;</>}
			{label}
			{labelPostfix && <span style={subLabelStyles}>{labelPostfix}</span>}
		</label>
	);

	// Render with Tooltip if tooltipText exists
	return tooltipText ? (
		<Tooltip
			content={
				<>
					<div style={{ fontSize: '13px', fontFamily: 'Inter-Medium', paddingBottom: '4px' }}>
						{tooltipHeading && <strong>{tooltipHeading}</strong>}{' '}
					</div>
					<div style={{ fontSize: '12px', fontFamily: 'Inter-Regular', color: '#545454' }}>
						{/* Display heading if it exists */}
						{tooltipText}
					</div>
				</>
			}
			type="basic"
			direction={direction} // Pass the direction prop to Tooltip
			delay={300}
			style={{ width: tooltipWidth || 'auto' }}
			offsetX={offsetX}
		>
			{labelElement}
		</Tooltip>
	) : (
		labelElement
	);
};

Label.propTypes = {
	label: PropTypes.string.isRequired,
	fontSize: PropTypes.string.isRequired,
	fontFamily: PropTypes.string.isRequired,
	type: PropTypes.oneOf([
		'primary',
		'secondary',
		'disabled',
		'highlight',
		'hyperlink',
		'hyperlink_hover',
		'hyperlink_focus',
		'error',
	]),
	style: PropTypes.object,
	onMouseHover: PropTypes.bool,
	tooltipText: PropTypes.string, // Optional prop for tooltip content
	tooltipWidth: PropTypes.string, // Optional prop for tooltip width
	onClick: PropTypes.func,
	labelPrefix: PropTypes.string,
	labelPostfix: PropTypes.string,
	textTransform: PropTypes.string,
	direction: PropTypes.oneOf(['top', 'bottom', 'left', 'right']), // PropType for direction
	tooltipHeading: PropTypes.string, // Optional prop for tooltip heading
	offsetX: PropTypes.number,
};

Label.defaultProps = {
	type: 'primary',
	direction: 'bottom', // Default direction value
};

export default Label;
